import {
    NAV_TOGGLE_REQUESTED_EVENT,
    NAV_OPEN_REQUESTED_EVENT,
    NAV_CLOSE_REQUESTED_EVENT,
} from "../../../../../../constants/nav_events";

// The online_app is a REFLECTOR of nav open/closed state, not its owner (plan 2026-07-15).
// It never mutates navOpen directly; it REQUESTS a change of the Nav webview (the sole owner)
// by dispatching one of the shared "-*Requested" events. The Nav persists navOpen and emits
// OnlineAppNav-open/-close, which the online_app then reflects (see online_app_nav.js).
//
// Dispatched at `window` to match the native broadcast target (nav.js listens there).

export function requestNavToggle() {
    window.dispatchEvent(new CustomEvent(NAV_TOGGLE_REQUESTED_EVENT));
}

export function requestNavOpen() {
    window.dispatchEvent(new CustomEvent(NAV_OPEN_REQUESTED_EVENT));
}

export function requestNavClose() {
    window.dispatchEvent(new CustomEvent(NAV_CLOSE_REQUESTED_EVENT));
}
